import { pick } from "lodash";

class ListAnalytics {

    constructor() {
        this.config = window.__mt;
    }


    setViewItemList(response, box) {
        let transferList = response.transferPriceList;
        let items = [];
        let box_base = this.getBaseBox(box);
        for (let index = 0; index < transferList.length; index++) {
            const element = transferList[index];
            const base = this.getBaseTransfer(response, element, index + 1, box_base);
            items.push(base);
        }

        let payload = {
            currency: "EUR",
            trip: box_base.trip, // round trip o one way
            origin: this.normalizeSlug(box_base.origin), // origen del viaje
            destiny: this.normalizeSlug(box_base.destiny), // destino del viaje
            passengers: box_base.total_pax, // número de pasajeros de la búsqueda
            origin_type: this.normalizeSlug(box_base.arrival_type), // tipo de origen: airport, address, station, port
            destiny_type: this.normalizeSlug(box_base.departure_type), // tipo de destino: airport, address, station, port
            advance_booking: box_base.advance_booking, // antelación de la reserva en horas
            results: items.length,
            items: items
        };


        this.setTag('view_item_list', payload)

    }

    formatDate(dateString) {
        if (!dateString) return '';
        const [date] = dateString.split(' ');
        const [year, month, day] = date.split('-');
        return `${day}${month}${year}`;
    }

    setAddToCart(response, transport, index, box, isCheckoutAddTocart = false) {
        let box_base = this.getBaseBox(box);
        let item = this.getBaseTransfer(response, transport, index, box_base);

        let payload = {
            event:'add_to_cart',
            trip: box_base.trip, // round trip o one way
            passengers: box_base.total_pax, // número de pasajeros de la búsqueda
            origin_type: this.normalizeSlug(box_base.arrival_type), // tipo de origen: airport, address, station, port
            destiny_type: this.normalizeSlug(box_base.departure_type), // tipo de destino: airport, address, station, port
            advance_booking: box_base.advance_booking, // antelación de la reserva en dias
            pickup_date: this.formatDate(box_base.arrival_date),
            ecommerce:{
            currency: "EUR",
            items: [item]
            }
        };


        if (box_base.trip == 'roundtrip') {
            payload.return_date = this.formatDate(box_base.departure_date);
            let item_return = this.getBaseTransfer(response, transport, index, box_base, true);
            item_return.price = item_return.price / 2;
            item_return.item_brand = 'return trip',
            payload.ecommerce.items[0].price = payload.ecommerce.items[0].price / 2;
            payload.ecommerce.items.push(item_return)
        }

        if (isCheckoutAddTocart) {
            payload.ecommerce.items.splice(0, 1)
        }


        this.setTagV2('add_to_cart', payload)
    }


    getBaseTransfer(searchList, transport, index, box, isRoundtrip = false) {
        let category = this.normalizeSlug(transport.transportName.split(" ")[1] || '');

        return {
            item_name:  this.normalizeSlug(transport.transportName.toLowerCase()),
            item_id: transport.transportId,
            price: transport.price,
            item_category: category,
            item_type: 'vehiculo',
            item_variant: transport.maxPassengers,
            quantity: 1,
            index: + index
        }
    }


    getBaseBox(box) {
        let params = {};

        params.adults = + box.adults;
        params.children = + box.children;
        params.infants = + box.infants;
        params.total_pax = params.adults + params.children + params.infants;


        params.arrival_date = box.arrival_date;
        params.arrival_type = this.normalizeSlug(box.arrival_type);
        params.departure_date = box.departure_date;
        params.departure_type = this.normalizeSlug(box.departure_type);

        params.arrival_datetime = this.config.fn.getDate(box.arrival_date);
        params.departure_datetime = this.config.fn.getDate(box.departure_date);
        params.current_date = this.config.fn.getDate();
        //debe calcular los dias de antelación en base a la fecha de llegada y la fecha actual
        params.advance_booking = Math.abs(Math.round(((params.arrival_datetime - params.current_date) / (1000 * 60 * 60 * 24))));

        params.origin = box.from.toLowerCase();
        params.destiny = box.to.toLowerCase();
        params.trip = box.transfer_type;

        return params;

    }


    setTag(event, args) {
        if (window.dataLayer) {
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push({event: `${event}`, ecommerce: args})
        }
    }

    setTagV2(event, args) {
        if (window.dataLayer) {
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push(args)
        }
    }

    normalizeSlug(text) {
        if (!text) return '';
        return text
            .toString()
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
    }

}

export const ListAnalytic = new ListAnalytics();
